<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="12" class="mb-3">
                <inter-input
                        label="Oggetto"
                        v-model="mailing.subject"
                        icon="edit"
                        :error="errors.name">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" md="12">
                <div class="text-center">
                    <b-form-checkbox v-model="mailing.sent_to_all" switch>
                        Invia a tutte le società
                    </b-form-checkbox>
                </div>
            </b-col>
            <b-col cols="12" md="12" class="mt-3" v-if="!mailing.sent_to_all">
                <inter-select
                        :multiple="true"
                        asyncFindAction="select/societies"
                        label="Destinatari"
                        v-model="societies"
                ></inter-select>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col class="AdminMailingsForm-UploadAttachment">
                <vue-dropzone
                        ref="InterDropZoneImport"
                        id="InterDropZoneImport"
                        :useCustomSlot="true"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploaded"
                        v-on:vdropzone-error="handleError"
                >
                    <div class="AdminMailingsForm-UploadAttachment-dropZone">
                        <h3 class="UploadImportFile-title">
                            Drag and drop to upload attachments!
                        </h3>
                        <div class="AdminMailingsForm-UploadAttachment-subtitle">
                            ...or click to select a file from your computer
                        </div>
                    </div>
                </vue-dropzone>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col>
                <inter-rich-text @onEditorUpdate="(value) => {mailing.text = value}"></inter-rich-text>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Mailing from "@/models/Mailing";
    import InterInput from "../../../components/form/inter-input/InterInput";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import InterRichText from "../../../components/inter-rich-text/InterRichText";
    import vue2Dropzone from 'vue2-dropzone';
    import {mapGetters} from 'vuex';

    export default {
        name: "AdminMailingsForm",
        components: {InterRichText, InterSelect, InterInput, vueDropzone: vue2Dropzone},
        data() {
            return {
                errors: {},
                societies: [],
                files: [],
                responses: []
            }
        },
        computed: {

            ...mapGetters(['accessToken']),

            dropzoneOptions: function () {
                return {
                    url: process.env.VUE_APP_API_URL + '/api/v1/mailings/upload-attachment',
                    headers: {
                        "client": process.env.VUE_APP_OAUTH_CLIENT_NAME,
                        "Authorization": 'Bearer ' + this.accessToken
                    },
                    uploadMultiple: true,
                    addRemoveLinks: true,
                    createImageThumbnails: false
                }
            },

        },
        props: {
            mailing: {
                type: Object,
                default: () => Object.assign({}, Mailing)
            },
        },
        methods: {

            uploaded: function (file, response) {
                this.files.push(file[0]);
                this.responses.push(response[0]);
                this.$emit('onUploaded', this.responses);
            },
            uploadManually: function () {
                this.$refs.InterDropZoneImport.removeAllFiles();
                this.responses = [];
                this.files = [];
            },
            handleError: function () {
                this.$refs.InterDropZoneImport.removeAllFiles();
                this.$bvToast.toast('File non caricato correttamente', {
                    title: 'Alert',
                    variant: 'warning'
                });
            },
        }
    }
</script>

<style scoped>

</style>